class PdpAnnouncementBar extends HTMLElement {
  static DURATION = 3600;
  static STORAGE_KEY = 'pdp-ab-end';

  connectedCallback() {
    this._hoursEl = this.querySelector('[data-pdp-ab-hours]');
    this._minutesEl = this.querySelector('[data-pdp-ab-minutes]');
    this._secondsEl = this.querySelector('[data-pdp-ab-seconds]');

    if (!this._hoursEl || !this._minutesEl || !this._secondsEl) return;

    this._initEndTime();
    this._tick();
    this._interval = setInterval(() => this._tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this._interval);
  }

  _initEndTime() {
    const stored = sessionStorage.getItem(PdpAnnouncementBar.STORAGE_KEY);
    const now = Date.now();

    if (stored) {
      const parsed = parseInt(stored, 10);
      if (!isNaN(parsed) && parsed > now) {
        this._endTime = parsed;
        return;
      }
    }

    this._endTime = now + PdpAnnouncementBar.DURATION * 1000;
    sessionStorage.setItem(PdpAnnouncementBar.STORAGE_KEY, String(this._endTime));
  }

  _tick() {
    const remaining = Math.max(0, Math.floor((this._endTime - Date.now()) / 1000));

    if (remaining === 0) {
      this._endTime = Date.now() + PdpAnnouncementBar.DURATION * 1000;
      sessionStorage.setItem(PdpAnnouncementBar.STORAGE_KEY, String(this._endTime));
    }

    const h = Math.floor(remaining / 3600);
    const m = Math.floor((remaining % 3600) / 60);
    const s = remaining % 60;

    this._hoursEl.textContent = String(h).padStart(2, '0');
    this._minutesEl.textContent = String(m).padStart(2, '0');
    this._secondsEl.textContent = String(s).padStart(2, '0');
  }
}

customElements.define('pdp-announcement-bar', PdpAnnouncementBar);
